import {Component, ViewChild} from '@angular/core';
import {DataTableComponent, Selectability, TableConfig} from '../../../components/data-table/data-table.component';
import {StringFilterComponent} from "../../../components/data-table/filters/string-filter/string-filter.component";
import {DateFilterComponent} from "../../../components/data-table/filters/date-filter/date-filter.component";
import {firstValueFrom} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {NumberFilterComponent} from "../../../components/data-table/filters/number-filter/number-filter.component";
import {BarrelsV1Service, Barrel, TaskType, Department, TaskStatus, WoodType} from "../../../apis/backend";
import {ListFilterComponent} from "../../../components/data-table/filters/list-filter/list-filter.component";
import {WoodTypeDisplayValues} from "../utils/wood-type";
import {DataTableCellDirective} from "../../../components/data-table/cell/data-table-cell.component";
import {BooleanFilterComponent} from "../../../components/data-table/filters/boolean-filter/boolean-filter.component";
import {BarrelDialogComponent} from "../dialog/barrel-dialog.component";

type FilterOption = {
  Value: string,
  Text: string
};

export const BarrelConfig: TableConfig = {
  ODataResourceName: 'barrels',
  Selectability: Selectability.SingleSelect,
  Columns: [
    {
      DisplayName: 'ID',
      PropertyName: 'BarrelID',
      FilterType: NumberFilterComponent,
      Formatter: (barrelID: number) => {
        let ret = document.createElement('a');
        ret.href = '/barrels/' + barrelID;
        ret.target = '_blank';
        ret.innerText = barrelID.toString();
        return ret;
      }
    },
    {
      DisplayName: 'Orig. BBL #',
      PropertyName: 'LegacyBarrelNumber',
      FilterType: NumberFilterComponent,
    },
    {
      DisplayName: 'Wood Type',
      PropertyName: 'WoodType',
      Formatter: (v: WoodType) => v ? WoodTypeDisplayValues[v] : ''
    },
    {
      DisplayName: 'Used?',
      PropertyName: 'IsUsed',
      FilterType: BooleanFilterComponent,
      Formatter: DataTableCellDirective.BooleanFormatter,
    },
    {
      DisplayName: 'Char',
      PropertyName: 'Char',
      FilterType: NumberFilterComponent
    },
    {
      DisplayName: 'Toast',
      PropertyName: 'ToastLevel',
    },
    {
      DisplayName: 'Description (Char)',
      PropertyName: 'Description',
      FilterType: StringFilterComponent,
    },
  ]
}

@Component({
  selector: 'barrel-overview',
  templateUrl: './barrel-overview.component.html',
})
export class BarrelOverviewComponent {
  
  public TableConfig = BarrelConfig;

  public Filter: string;
  
  public PageIndex: number;
  public PageCount: number;
  
  @ViewChild(DataTableComponent)
  public DataTable: DataTableComponent;
  
  constructor(
      private _barrelService: BarrelsV1Service,
      private _modalService: NgbModal) {
  }

  public CreateBarrel() {
    this._modalService.open(BarrelDialogComponent, { size: 'lg' }).result
        .then((barrel: Barrel) => {
          return firstValueFrom(this._barrelService.createBarrel(barrel));
        })
        .then(() => {
          this.DataTable.Refresh();
        });
  }

  public EditBarrel(barrel?: Barrel) {
    if (!barrel) {
      barrel = this.DataTable.GetSelection();
    }
    if (barrel) {
      barrel = <Barrel>JSON.parse(JSON.stringify(barrel));
      let modal = this._modalService.open(BarrelDialogComponent, { size: 'lg' });
      modal.componentInstance.Barrel = barrel;

      modal.result
          .then((barrel: Barrel) => {
            return firstValueFrom(this._barrelService.updateBarrel(barrel.BarrelID, barrel));
          })
          .then(() => {
            this.DataTable.Refresh();
          });
    }
  }
}
